import React, { useState } from 'react';
import BaseLayout from '../../layouts/BaseLayout';
import ChatSidebar from './components/ChatSidebar';
import ChatWindow from './components/ChatWindow';

const Chat = () => {
  const [selectedUser, setSelectedUser] = useState(null);

  return (
    <BaseLayout>
      <div className="h-[calc(100vh-theme(spacing.28))] flex bg-white rounded-lg overflow-hidden">
        <ChatSidebar onSelectUser={setSelectedUser} selectedUser={selectedUser} />
        {selectedUser ? (
          <ChatWindow user={selectedUser} />
        ) : (
          <div className="flex-1 flex items-center justify-center text-gray-500">
            Select a conversation to start messaging
          </div>
        )}
      </div>
    </BaseLayout>
  );
};

export default Chat;
